<script lang="ts">
    import {createEventDispatcher} from "svelte";
    import Infobox from "../Infobox.svelte";
    import RadioBtn from "../form/RadioBtn.svelte";
    import CoordinatorBox from "../form/CoordinatorBox.svelte";
    import {ASSET_URL} from "../../config";
    import {TextArea} from "carbon-components-svelte";
    import TextareaBox from "../form/TextareaBox.svelte";
    import ErrorBox from "../form/ErrorBox.svelte";
    import {entityStore, myStore} from "../../stores.js";
    import BankAccountBox from "../form/BankAccountBox.svelte";
    import FileUploadBtn from "../form/FileUploadBtn.svelte";
    import UploadInfoBox from "../form/UploadInfoBox.svelte";

    const dispatch = createEventDispatcher();
    let submitted:Boolean = false;

    let validStep = null;
    const stepKey = "step3";

    export let disabledFields = true;
    /*
    function onSubmitBtnClicked(){
       dispatch('submitBtnClicked');
    }

     */

    const add = () => {
        console.log("add coordinator");
        $myStore.addField(`step3.pactCoordinators`, {firstname: null, lastname: null, description: null,files:[],type:null,communities:[]}, $myStore.data.step3.pactCoordinators.length + 1);
       // $myStore.addField(`pactCoordinators`, {}, $myStore.data.pactCoordinators.length + 1);

    };

    let coordinators = $myStore.data.step3.pactCoordinators;
    let hasCoordinators = $myStore.data.step3.hasPactCoordinators;


    $: if($myStore.data.step3.hasPactCoordinators === 'true'){
        console.log("has Coordi!!!!");
    }

    /*

    if ($myStore.data.hasCoordinators === 'true' && $myStore.data.pactCoordinators.length == 0) {
            console.log("create first coordinator");
         $myStore.addField('pactCoordinators',{},0);
    } else {
        console.log("remove all coordinators")
        $myStore.resetField('pactCoordinators');

    }

     */

    function checkValidity(key){
        let steps =  $entityStore.steps;
        const index = steps.findIndex((s) => s.key == key)
        if(steps[index]){
            validStep = steps[index].valid; // !step.valid && step.touched;

            steps[index].touched = true;

            if(validStep){
                //open next accordion
                    //open next accordion
                    if(index < steps.length){
                        steps[index].expanded = false;
                        steps[index].isActive = false;
                        steps[index].disabled = false;

                        steps[index+1].disabled = false;
                        steps[index+1].isActive = true;
                        steps[index+1].expanded = true;


                    }

            }

            entityStore.update($entityStore => ({
                ...$entityStore,
                steps
            }));
        }
    }

    function validateCurrentStep(){
        submitted = true;
        //validateStep(stepKey);
        checkValidity(stepKey)

        console.log("steps after: ",$entityStore.steps);
    }


    const remove = index => () => {
        console.log("remove coordinator at index ",index);
       // $myStore.resetField(`step3.coordinators`, index);
        $myStore.unsetField(`step3.pactCoordinators.${index}`);
    }


</script>
<!-- translation example: {$_('introText')}-->
<div class="step">

    <div class="section no-border">
        <Infobox customClass="mb-5">
            Dans le cadre du pacte communal du vivre-ensemble interculturel, les communes peuvent s’adjoindre les
            services d’un·e coordinateur·trice pacte communal, qui accompagne, assiste et soutient la commune et assure
            le suivi du pacte communal. Le·la coordinateur·trice pacte communal est soit un·e fonctionnaire ou un·e
            employé·e communal·e, soit un·e coordinateur·trice pacte communal externe. Le·la coordinateur pacte communal
            externe peut être une personne physique ou morale (association, entreprise etc.). S’il s’agit d’une personne
            morale, celle-ci doit désigner l’identité de la ou des personnes physiques qui exerceront le rôle de
            coordinateur·trice pacte communal. Lorsque plusieurs communes signent le pacte communal ensemble, il peut
            être judicieux d'engager plusieurs coordinateur·trice·s.
        </Infobox>

        <h3 class="title">Avez-vous désigné un·e·des coordinateur·trice·s pacte communal ?</h3>
        <div class="mb-3">
            <RadioBtn disabled={disabledFields} key="hasCoordinator"  type="yes" title="Oui" value="1" checked={$myStore.data.step3.hasCoordinators}
                      group="step3.hasCoordinators"></RadioBtn>
            <RadioBtn disabled={disabledFields} key="hasCoordinator"  type="no" title="Non" value="0" checked={!$myStore.data.step3.hasCoordinators}
                      group="step3.hasCoordinators"></RadioBtn>
        </div>

    </div>
    {#if $myStore.data.step3.hasCoordinators}<!-- $myStore.data.pactIsSignedBySyndicate === 'true'-->
        <div class="coordinator-repeater">
            {#if $myStore.data.step3.pactCoordinators }
                {#each $myStore.data.step3.pactCoordinators as item,index}
                    <CoordinatorBox disabled={disabledFields} title="Nom·s du·de la·des coordinateur·trice·s pacte communal" {index}
                                    on:remove={remove(index)}></CoordinatorBox>
                {/each}
                {/if}
            <div class="add-btn-box">
                <div class="add-btn" on:click={add}>
                    <img src="{ASSET_URL}/assets/img/icons/add.svg"/>
                </div>
            </div>

        </div>

    {/if}

    <div class="section no-border">
        <h3 class="title">Désirez-vous recruter un·e·des coordinateur·trice·s pacte communal ?</h3>
        <div>
            <RadioBtn key="wantFutureCoord" type="yes" title="Oui" value="YES" checked="{$myStore.data.step3.wantFutureCoordinators === 'YES'}"
                      group="step3.wantFutureCoordinators"></RadioBtn>
            <RadioBtn  key="wantFutureCoord" type="no" title="Non" value="NO" checked="{$myStore.data.step3.wantFutureCoordinators === 'NO'}"
                      group="step3.wantFutureCoordinators"></RadioBtn>
            <RadioBtn key="wantFutureCoord" type="neutral" title="Je ne sais pas" value="MAYBE"
                      checked="{$myStore.data.step3.wantFutureCoordinators === 'MAYBE'}"
                      group="step3.wantFutureCoordinators"></RadioBtn>
        </div>

    </div>
    {#if $myStore.data.step3.wantFutureCoordinators === 'YES' }

        <div class="section no-border">
            <div class="custom-box">
                <h4 class="title">Annexes à fournir</h4>
                <UploadInfoBox
                        withoutOverlay={true}
                        text="Profil·s du·de·la·des coordinateur·trice·s à recruter, accompagné·s d’une description des tâches">
                </UploadInfoBox>
                <div class="custom-row mt-3">
                    <FileUploadBtn fieldName="step3.futureCoordinatorFiles" errorClass={$myStore.errors.step3?.futureCoordinatorFiles}></FileUploadBtn>
                </div>

            </div>

        </div>
    {/if}

    <div class="section no-border">

        <h3 class="title">Si vous avez désigné ou désirez recruter un·e·des coordinateur·trice·s externe·s, veuillez nommer le prestataire externe (association, entreprise, freelance etc.) qui fournira ce service</h3>

        <TextareaBox placeholder="Veuillez écrire dans cette zone de texte le nom de l’association, de l’entreprise, du·de la freelance etc. auquel·à laquelle vous confierez ou voudriez confier la tâche de coordinateur·trice pacte communale." name="step3.externalCoordinatorDescription" errorClass={$myStore.errors.step3.externalCoordinatorDescription}></TextareaBox>


    </div>

    {#if submitted && !validStep}
        <ErrorBox>Les champs avec un cadre rouge ne sont pas encore remplis ou sont erronés.</ErrorBox>
    {/if}
    {#if !submitted || !validStep}
        <div class="step-validation-btn">
            <button disabled={disabledFields} class="mt-2 btn btn-brand submitBtn" on:click={validateCurrentStep}>continuer</button>

        </div>
    {/if}
</div>

<style lang="scss">

  .section {
    border: none !important;
  }

  .coordinator-repeater {

    display: flex;
    margin-top: 3rem;
    margin-bottom: 3rem;
    //column-gap: 2rem;
    flex-wrap: wrap;
    gap: 2rem;

  }

  .add-btn-box {
    display: flex;
    align-items: center;
    margin-left: 2rem;
  }

  .add-btn {
    background: $secondary-color;
    color: white;
    border-radius: 9px;
    cursor: pointer;
    padding: 10px;
    display: inline-flex;
    align-content: center;
    justify-content: center;

    img {
      height: 1.5rem;
      width: 1.5rem;
    }
  }

</style>
